/** Check attribute values match */
export const valuesMatch = (
	currentValue: any,
	originalValue: any,
	multipleValues = false,
): boolean => {
	currentValue = Array.isArray(currentValue)
		? currentValue.join()
		: currentValue;
	originalValue = Array.isArray(originalValue)
		? originalValue.join()
		: originalValue;

	// Overriding mutliple values with a value
	if (multipleValues && currentValue != null) return false;

	// Treat null as empty
	if (currentValue === '' && originalValue == null) return true;

	// Difference in how java sends back dates mm/dd/yyyy
	// and we send/manage in yyyy-mm-dd
	if (
		originalValue &&
		originalValue.toString().match(/^\d{2}\/\d{2}\/\d{4}$/)
	) {
		originalValue = originalValue.replace(/(..).(..).(....)/, '$3-$1-$2');
	}
	if (currentValue && currentValue.toString().match(/^\d{2}\/\d{2}\/\d{4}$/)) {
		currentValue = currentValue.replace(/(..).(..).(....)/, '$3-$1-$2');
	}

	if (currentValue == null && originalValue == null) return true;
	if (currentValue == null && originalValue != null) return false;
	if (currentValue != null && originalValue == null) return false;

	return JSON.stringify(currentValue) === JSON.stringify(originalValue);
};

export default valuesMatch;
